import { useEffect, useRef } from 'react';

const testimonials = [
  {
    name: "Liam O'Sullivan",
    business: "O'Sullivan Plumbing Dublin",
    quote: "AI paid for itself month one. Revenue up 40% in 3 months.",
    stars: 5,
  },
  {
    name: 'Jennifer Walsh',
    business: 'Walsh HVAC',
    quote: "Team focuses on work. AI handles everything. Haven't missed a lead since.",
    stars: 5,
  },
  {
    name: 'Tom Davidson',
    business: 'Davidson Mechanical',
    quote: 'Live in a day. New jobs booked within a week.',
    stars: 5,
  },
];

const trustItems = [
  { icon: '🔒', label: 'GDPR' },
  { icon: '🇮🇪', label: 'Irish' },
  { icon: '⭐', label: '5-Star' },
  { icon: '🔧', label: 'Tradesman-Built' },
  { icon: '📡', label: '24/7 On' },
];

export default function Proof() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-16 px-5 overflow-hidden"
      style={{ backgroundColor: '#080F0C' }}
    >
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(to right, transparent, rgba(10,92,68,0.5), transparent)' }}
      />

      <div className="max-w-5xl mx-auto">
        {/* Headline */}
        <div className="reveal opacity-0 mb-8" style={{ transitionDelay: '0ms' }}>
          <h2
            className="font-bebas text-brand-text text-center"
            style={{ fontSize: 'clamp(38px, 11vw, 52px)' }}
          >
            Real Trades. Real Results.
          </h2>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="reveal opacity-0 rounded-2xl p-5"
              style={{
                transitionDelay: `${i * 120}ms`,
                backgroundColor: '#0a1812',
                border: '1px solid rgba(10,92,68,0.35)',
              }}
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.stars }).map((_, si) => (
                  <span key={si} style={{ color: '#AAFF45', fontSize: '14px' }}>★</span>
                ))}
              </div>

              {/* Quote */}
              <p className="font-dm text-brand-text text-sm leading-relaxed mb-3 italic">
                "{t.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-2">
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'rgba(10,92,68,0.5)', border: '1px solid rgba(10,92,68,0.6)' }}
                >
                  <span className="font-bebas text-brand-accent text-sm">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-dm font-bold text-brand-text text-xs">{t.name}</p>
                  <p className="font-dm text-brand-grey text-xs">{t.business}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust bar */}
        <div
          className="reveal opacity-0 flex flex-wrap justify-center gap-3"
          style={{ transitionDelay: '400ms' }}
        >
          {trustItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-1.5 px-3 py-2 rounded-full font-dm text-xs font-medium"
              style={{
                backgroundColor: 'rgba(10,92,68,0.15)',
                border: '1px solid rgba(10,92,68,0.3)',
                color: '#A0A8A4',
              }}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
